import { IAppAction } from "../appAction";

export const tagsActions = {
  FETCH_TAGS: "FETCH_TAGS",
  FETCH_TAGS_SUCCESS: "FETCH_TAGS_SUCCESS",
  FETCH_TAGS_ERROR: "FETCH_TAGS_ERROR",
};

export const fetchTags = (): IAppAction => ({
  type: tagsActions.FETCH_TAGS
});

export const fetchTagsSuccess = (payload: any): IAppAction => ({
  type: tagsActions.FETCH_TAGS_SUCCESS,
  payload
});

export const fetchTagsError = (error: Error): IAppAction => ({
  type: tagsActions.FETCH_TAGS_ERROR,
  payload: error
});
